import React, { useEffect } from 'react';
import { Select, Stack, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useTranslation } from 'react-i18next';
import { Account } from '../AccountCard';
import { SyncRuleFormValues } from '../sync_rule/interface';
import { buildSourceCalendarOptions, findPrimaryCalendarUuid } from '../sync_rule/calendarOptions';

export const OnboardingSourceCalendarSelect: React.FC<{
    accounts: Account[];
    form: UseFormReturnType<SyncRuleFormValues>;
}> = ({ accounts, form }) => {
    const { t } = useTranslation(['app']);
    const sourceCalendars = buildSourceCalendarOptions(accounts);

    useEffect(() => {
        if (!form.values.source) {
            const primary = findPrimaryCalendarUuid(accounts);
            if (primary) {
                form.setFieldValue('source', primary);
            }
        }
    }, [accounts]);

    return (
        <Stack gap="lg">
            <Stack gap="xs">
                <Text size="xl" fw={600}>{t('dashboard.onboarding.step2.title')}</Text>
                <Text c="dimmed">{t('dashboard.onboarding.step2.description')}</Text>
            </Stack>
            <Select
                placeholder={t('dashboard.sync.draft.source')}
                data={sourceCalendars}
                {...form.getInputProps('source')}
                searchable
                required
                size="md"
                comboboxProps={{ styles: { search: { fontSize: '16px' } } }}
            />
        </Stack>
    );
};
